import * as React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import '../../../App.css'
import '../../../css/modal.scss'
import { updateAlert } from '../../../store/common/common_action'
import TopSection from './TopSection'
import MiddleSection from './MiddleSection'
import BottomSection from './BottomSection'
import { clickElement } from '../../common/helper'
import Dashboard from '../../common/DashBoard'

const BranchTransferReceive = ({ data, updateAlert }) => {
  const { common } = data

  const { cnsgnmntTypes, alert, BranchReceiveDashboard } = common
  const [allSelected, setAllselected] = useState({
    selectDestCity: 'All',
    selectDestBranch: 'All',
    selectBookingtype: 'All',
    selectconsignmentType: 'All',
    selectedButtonType: 'Booking',
  })
  const [selectedChallanData, setSelectedChallanData] = useState([])
  const [selectedVehicleData, setSelectedVehicleData] = useState([])
  const [dashboardOpen, setDashboardOpen] = useState(true)
  const [selectedData, setSelectedData] = useState([])
  const [state, setState] = useState({
    showListTable: false,
    showListAllTable: false,
  })

  const { showListTable } = state

  const [topSelectedData, setTopSelectedData] = useState({
    DFromBranch: null,
    consignmentData: null,
    SelectedVehicle: '',
    resetData: false,
    changeFromBranch: false,
  })
  const [showBtnList, setShowBtnList] = useState(true)
  const [tSecDropData, setTSecDropData] = useState({
    selectconsignmentType: '',
    SellectedChallanNumber: 'All',
  })
  const [chaVehWise,setChaVehWise]=useState(0)
  useEffect(() => {
    if (topSelectedData.DFromBranch !== null) {
      clickElement('firstGoBTNBranchReceive')
    }
  }, [topSelectedData.DFromBranch])
  useEffect(() => {
    if (topSelectedData.SelectedVehicle !== '') {
      clickElement('secondGoBTNBranchReceive')
    }
  }, [topSelectedData.SelectedVehicle])
  useEffect(() => {
    setTopSelectedData({ ...topSelectedData, consignmentData: cnsgnmntTypes })
  }, [])
  useEffect(() => {
    setTopSelectedData({ ...topSelectedData, SelectedVehicle: '', changeFromBranch: true })
    setState({
      showListTable: false,
      showListAllTable: false,
    })
    setSelectedData([])
  }, [topSelectedData.DFromBranch])
  useEffect(() => {
    //setTSecDropData({ ...tSecDropData, SellectedChallanNumber: selectedChallanData?.[0] })
    setTopSelectedData((prev)=>({...prev,SelectedVehicle:selectedChallanData?.[0]}))
  }, [selectedChallanData])
  useEffect(() => {
    setTSecDropData({ ...tSecDropData, SellectedChallanNumber: '' })
  }, [])
  useEffect(() => {
    setState({
      showListTable: false,
      showListAllTable: false,
    })
    setSelectedData([])
  }, [topSelectedData.SelectedVehicle, tSecDropData])
  const handleAlert = (msg = false) => {
    if (!(msg instanceof Event)) {
      if (msg) {
        updateAlert({ show: true, msg })
      } else {
        updateAlert({ show: false, msg: '' })
      }
    }
  }
  const testInp = React.useRef(null)
  const testInp1 = React.useRef(null)
  return (
    <>
      <TopSection
        setState={setState}
        topSelectedData={topSelectedData}
        setTopSelectedData={setTopSelectedData}
        tSecDropData={tSecDropData}
        setTSecDropData={setTSecDropData}
        setSelectedData={setSelectedData}
        setShowBtnList={setShowBtnList}
        showBtnList={showBtnList}
        selectedChallanData={selectedChallanData}
        setSelectedChallanData={setSelectedChallanData}
        selectedVehicleData={selectedVehicleData}
        setSelectedVehicleData={setSelectedVehicleData}
        handleAlert={handleAlert}
        setChaVehWise={setChaVehWise}
      />
      {dashboardOpen && showListTable === false ? (
        <Dashboard
          setDashboardOpen={setDashboardOpen}
          handleAlert={handleAlert}
          DashboardData={BranchReceiveDashboard}
          Type="BranchReceive"
        />
      ) : (
        ''
      )}
      {showListTable ? (
        <MiddleSection
          details={allSelected}
          inputCheck={state.showListAllTable}
          selelectedData={selectedData}
          setSelectedData={setSelectedData}
          topSelectedData={topSelectedData}
          tSecDropData={tSecDropData}
          handleAlert={handleAlert}
        />
      ) : (
        ''
      )}
      <BottomSection
        topSelectedData={topSelectedData}
        tSecDropData={tSecDropData}
        selectedData={selectedData}
        setTSecDropData={setTSecDropData}
        indexSetState={setState}
        setTopSelectedData={setTopSelectedData}
        setSelectedData={setSelectedData}
        setShowBtnList={setShowBtnList}
        setSelectedChallanData={setSelectedChallanData}
        setSelectedVehicleData={setSelectedVehicleData}
        handleAlert={handleAlert}
        inputCheck={state.showListAllTable}
        chaVehWise={chaVehWise}

      />
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateAlert,
}

export default connect(mapStateToProps, mapDispatchToProps)(BranchTransferReceive)
